import { useEffect } from 'react'
import { useSelector } from 'react-redux'

const AUTH_SYNC_KEY = 'auth_sync_timestamp'
const SYNC_DEBOUNCE_MS = 500 // Debounce reloads

let lastReloadTime = 0

export const useAuthSync = () => {
    const currentUser = useSelector(state => state.auth.user)

    useEffect(() => {
        const handleStorageChange = e => {
            // Only react to auth sync changes
            if (e.key === AUTH_SYNC_KEY) {
                const now = Date.now()
                // Prevent reload if we just reloaded recently
                if (now - lastReloadTime < SYNC_DEBOUNCE_MS) {
                    return
                }

                // Parse the timestamp from storage
                const newTimestamp = parseInt(e.newValue, 10)
                const oldTimestamp = parseInt(e.oldValue, 10)

                // Only reload if this is a newer timestamp
                if (!isNaN(newTimestamp) && (isNaN(oldTimestamp) || newTimestamp > oldTimestamp)) {
                    lastReloadTime = now
                    window.location.reload()
                }
            }
        }

        // Listen for storage events from other tabs
        window.addEventListener('storage', handleStorageChange)

        return () => {
            window.removeEventListener('storage', handleStorageChange)
        }
    }, [currentUser])

    return null
}
